module.exports = __webpack_public_path__ + "static/img/certificate5.12866bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certificate5.jpg
// module id = vZTa
// module chunks = 1